import React from 'react';
import styles from './stripes-skeleton.module.scss';
import Skeleton from '@smart-tv/components/skeleton';

export const StripesSkeleton: React.FC = () => {
  const elements = [...Array(5)];
  const rows = [...Array(3)];

  // Rendered as a plain block outside the page's own scroll container, so a scroll position
  // left over from before a dialog opened would otherwise make this shorter skeleton appear
  // cut off/scrolled instead of starting at the top.
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <div className={styles['stripes-skeleton']}>
      <div className={styles['stripes-skeleton__hero']}>
        <Skeleton height={87} width="40%" />
        <Skeleton height={31} width="10%" />
      </div>
      {rows.map((_, rowIndex) => (
        <div key={'skeletonRow' + rowIndex} className={styles['stripes-skeleton__row']}>
          <Skeleton
            className={styles['stripes-skeleton__content-items-header']}
            height={35}
            width="30%"
          />
          <div className={styles['stripes-skeleton__elements']}>
            {elements.map((_, index) => (
              <Skeleton
                key={'skeletonItem' + rowIndex + '-' + index}
                className={styles['stripes-skeleton__content-item']}
                variant="rect"
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StripesSkeleton;
